<h2>{{'featured_events' | transloco}}</h2>
<div app-loading-content [height]="250" [loading]="featuredEvents.loadingRef === true" >
  <ngx-slick-carousel #carousel class="carousel" [config]="slideConfig" #slickModal="slick-carousel">
    <div ngxSlickItem *ngFor="let event of featuredEventsList" class="slide event-teaser">
      <div>
      <a *ngIf="event.statusId <=1; else noActive"  [href]="lang + 'competition/'+event?.id.toString()">
        <img [src]="'//extranet.worldarchery.sport/CompetitionLogos/?Id=' + event.id" class="event-teaser__logo" />
        <div class="event-teaser__title">{{ event.nameshort ? event.nameshort : event.name  }}</div>
        <app-date-event [dateFrom]="event.dateFrom" [dateTo]="event.dateTo"></app-date-event>
      </a>
      <ng-template #noActive>
        <div>
          <img [src]="'//extranet.worldarchery.sport/CompetitionLogos/?Id=' + event.id" class="event-teaser__logo" />
        <div [ngStyle]="{'cursor':'default', 'color':'#989898'}" class="event-teaser__title">{{ event.nameshort ? event.nameshort : event.name  }}</div>
        <app-date-event [dateFrom]="event.dateFrom" [dateTo]="event.dateTo"></app-date-event>
        </div>
      </ng-template>
    </div>
    </div>
  </ngx-slick-carousel>
</div>

<ng-template #loading>
  <div class="loading-throbber"></div>
</ng-template>
